/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Rukara 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Kawangire": ["Butimba I", "Butimba II", "Gakenyeri", "Gitega", "Karama", "Kidogo", "Kinunga", "Rwempasha"],
  "Rukara": ["Butimba", "Buyonza", "Gitarama", "Ibiza", "Kabuga", "Kamajigija", "Karambo I", "Karambo II", "Karubamba", "Kinunga I", "Kinunga II", "Mitungo", "Mumuri", "Munyinya", "Muzizi", "Nyagaharabuge", "Nyirarukara", "Uruyenzi"],
  "Rwimishinya": ["Akabare I", "Akabare II", "Karagari I", "Karagari II", "Kigwene I", "Kigwene II", "Kinunga I", "Kinunga II", "Mirambi I", "Mirambi II", "Mirambi III", "Nyarutunga I", "Nyarutunga II"]
};